<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <h4>Podatki za blagajno:</h4>
        <v-text-field
          v-model="form.moniker"
          label="Oznaka uporabnika *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.moniker.required)"
        >
          <FormErrorsLine v-if="!$v.form.moniker.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
          v-show="companyHasUserTypes"
          :items="userTypes"
          item-text="name"
          item-value="id"
          v-model="form.user_type"
          label="Tip uporabnika *"
          @change="updatePermissions"
          :disabled="isSuperAdministrator"
        ></v-select>
        <FormErrors
          v-if="companyHasUserTypes && $v.form.$error && (!$v.form.user_type.required)"
        >
          <FormErrorsLine v-if="!$v.form.user_type.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.tax_number"
          label="Davčna številka"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.tax_number.isTaxNumber)"
        >
          <FormErrorsLine v-if="!$v.form.tax_number.isTaxNumber" text="Davčna številka ni veljavna" />
        </FormErrors>
        <v-text-field
          v-if="newUser"
          v-model="localPin"
          label="Pin"
        ></v-text-field>

        <h4 class="mt-12">Osebni podatki:</h4>
        <v-text-field
          v-model="form.complete_name"
          label="Ime in priimek"
        ></v-text-field>
        <v-text-field
          v-model="form.address"
          label="Ulica in hišna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.post_code"
          label="Poštna številka"
          @blur="fillCity"
        ></v-text-field>
        <v-text-field
          v-model="form.city"
          label="Mesto"
        ></v-text-field>
        <v-text-field
          v-model="form.phone"
          label="Telefon / Kontakt"
        ></v-text-field>

        <h4 class="mt-12">Podatki za CMS:</h4>
        <v-text-field
          v-model="form.username"
          label="Uporabniško ime"
        ></v-text-field>
        <v-text-field
          v-if="newUser"
          v-model="form.password"
          type="password"
          label="Geslo"
        ></v-text-field>
        <FormErrors
          v-if="newUser && $v.form.$error && (!$v.form.password.alphaNum || !$v.form.password.minLength || !$v.form.password.maxLength)"
        >
          <FormErrorsLine v-if="!$v.form.password.alphaNum" text="Dovoljene so le male črke, velike črke in številke" />
          <FormErrorsLine v-if="!$v.form.password.minLength || !$v.form.password.maxLength" text="Dolžina gesla mora biti med 6 in 20 znakov" />
        </FormErrors>
        <v-text-field
          v-if="newUser"
          v-model="form.password2"
          type="password"
          label="Geslo, ponovno"
        ></v-text-field>
        <FormErrors
          v-if="newUser && $v.form.$error && (!$v.form.password2.sameAsPassword)"
        >
          <FormErrorsLine v-if="!$v.form.password2.sameAsPassword" text="Gesli se ne ujemata" />
        </FormErrors>

        <!-- <div v-if="!newUser && !user.is_administrator">
          <p class="mt-12">Pravice:</p>
          <v-checkbox
            color="#0F998E"
            v-model="form.repeat_print_permission"
            label="Ponovno tiskanje"
          ></v-checkbox>
          <v-checkbox
            color="#0F998E"
            v-model="form.delete_permission"
            label="Brisanje"
          ></v-checkbox>
          <v-checkbox
            color="#0F998E"
            v-model="form.discount_permission"
            label="Dodajanje popusta"
          ></v-checkbox>
          <v-checkbox
            color="#0F998E"
            v-model="form.sales_log_permission"
            label="Pregled statistike prodaje"
          ></v-checkbox>
          <v-checkbox
            color="#0F998E"
            v-model="form.negative_amount_permission"
            label="Storno račun"
          ></v-checkbox>
        </div> -->

        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn v-if="newUser" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in nov</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { postName } from '@/utils/postCodes'
import { required, alphaNum, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import { isValidTaxNumber } from '@/utils/taxNumber'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    userTypes: {
      required: true,
      type: Array
    },
    user: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      localPin: null,
      emptyForm: {
        username: null,
        password: '',
        password2: '',
        pin_code: null,
        pin_code2: null,
        complete_name: null,
        moniker: null,
        tax_number: null,
        user_type: null,
        address: null,
        post_code: null,
        city: null,
        phone: null,
        repeat_print_permission: null,
        delete_permission: null,
        discount_permission: null,
        sales_log_permission: null,
        negative_amount_permission: null
      },
      form: {}
    }
  },
  validations () {
    return {
      form: {
        password: {
          alphaNum,
          minLength: minLength(6),
          maxLength: maxLength(20)
        },
        password2: {
          sameAsPassword: sameAs('password')
        },
        pin_code2: {
          sameAsPin: sameAs('pin_code')
        },
        tax_number: {
          isTaxNumber: val => isValidTaxNumber(val) || val === '' || val === null
        },
        moniker: {
          required
        },
        user_type: {
          required
        }
      }
    }
  },
  computed: {
    newUser () {
      return this.user ? Object.keys(this.user).length === 0 : true
    },
    companyHasUserTypes () {
      return this.$store.state.companies.myCompany ? this.$store.state.companies.myCompany.company_type === 1 : true
    },
    isSuperAdministrator () {
      return !this.newUser && this.user.is_super_administrator
    }
  },
  methods: {
    updatePermissions () {
      const userType = this.userTypes.find(x => x.id === this.form.user_type)
      this.form.repeat_print_permission = userType.repeat_print_permission
      this.form.delete_permission = userType.delete_permission
      this.form.discount_permission = userType.discount_permission
      this.form.sales_log_permission = userType.sales_log_permission
      this.form.negative_amount_permission = userType.negative_amount_permission
    },
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.localPin = null
      if (!this.companyHasUserTypes) {
        this.form.user_type = this.userTypes[0].id
      }
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    },
    fillCity () {
      this.form = { ...this.form, city: postName(this.form.post_code) }
    }
  },
  created () {
    this.form = { ...this.emptyForm, ...this.user, ...{ pin_code: null } }
    if (!this.companyHasUserTypes) {
      this.form.user_type = this.userTypes[0].id
    }
  },
  watch: {
    localPin (localPin) {
      this.form.pin_code = parseInt(localPin)
      this.form.pin_code2 = parseInt(localPin)
    }
  }
}
</script>
